/* TEMPORYA — reveal des gammes à l’entrée dans la zone visible */
(() => {
  const init = () => {
    const section = document.querySelector('.zavero-ranges');
    if (!section || section.dataset.revealReady === 'true') return;
    section.dataset.revealReady = 'true';
    document.documentElement.classList.add('temporya-scroll-reveal-enabled');
    const cards = section.querySelectorAll('.zavero-range');
    cards.forEach((card, index) => {
      card.classList.add('temporya-reveal-item');
      card.style.setProperty('--temporya-reveal-delay', (index * 140) + 'ms');
    });
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cards.forEach(card => card.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -4% 0px' });
    cards.forEach(card => observer.observe(card));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();